<script>
    import createVisibilityObserver from '../visibilityObserver.svelte.js';

    /**
     * Overlay component which is rendered once in the app
     * Exposes 3 slots for inserting header, content & footer
     */

    /**
     * @typedef {Object} Props
     * @property {boolean} [open]
     * @property {import('svelte').Snippet} [header]
     * @property {import('svelte').Snippet} [content]
     * @property {import('svelte').Snippet} [footer]
     */
    /** @type {Props} */
    // prettier-ignore
    let {
        open = false,
        header,
        content,
        footer
    } = $props();

    // For header & footer scroll shadows:
    let fullyScrolledUp = $state(true);
    let fullyScrolledDown = $state(true);
    let overlayContent = $state();
</script>

<style>
    .overlay {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        flex-direction: column;
        background: var(--color-bg-default);
        opacity: 1;
        z-index: var(--layer-4);
        transition:
            opacity 0.4s,
            z-index 0.4s;

        /* combine aria-hidden (for SR blocking) */
        /* and opacity + z-index transition for the fade & hide */
        &[aria-hidden='true'] {
            opacity: 0;
            z-index: var(--layer-back);
        }
        @media screen and (--mq-minwidth-medium) {
            top: 8rem;
        }

        & > .overlay-content {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            overflow: hidden auto;
        }

        & > header,
        & > footer {
            z-index: var(--layer-1);
        }
    }
</style>

<div class="overlay" aria-hidden={!open}>
    <header role="none" class:shadow-bottom={!fullyScrolledUp}>
        {@render header?.()}
    </header>
    <div class="overlay-content" role="main" aria-labelledby="a11y-overlay" bind:this={overlayContent}>
        <div
            class="scroll-first-child"
            {@attach createVisibilityObserver(overlayContent)}
            onisVisible={e => (fullyScrolledUp = e.detail)}>
        </div>
        {@render content?.()}
        <div
            class="scroll-last-child"
            {@attach createVisibilityObserver(overlayContent)}
            onisVisible={e => (fullyScrolledDown = e.detail)}>
        </div>
    </div>
    <footer class:shadow-top={!fullyScrolledDown}>
        {@render footer?.()}
    </footer>
</div>
